import React from "react";

import { Dropdown, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

import VideoStudioContext from "components/stories/video-studio/contexts/VideoStudioContext";

import styles from "./buildertemplates.module.scss";
import { useTemplateBuilder } from "./context/TemplateBuilderContext";

const CreateTemplateButton = () => {
  const { startTemplateBuilder, templateBuilderSelection } = useTemplateBuilder();

  const handleSelectTemplate = (value: any) => {
    if (value !== templateBuilderSelection) {
      startTemplateBuilder(value);
    }
  };

  return (
    <Dropdown
      className={styles.dropdown}
      onChange={handleSelectTemplate}
      selected=""
    >
      <Dropdown.Button>
        <Icon icon="plus" />
        <span><Trans>Create Template</Trans></span>
      </Dropdown.Button>
      <Dropdown.ListBox>
        <Dropdown.Option value="video">
          <VideoStudioContext
            CustomButton={
              ({ onClick }) => (
                <div onClick={onClick}>
                  <Trans>Video Template</Trans>
                </div>
              )
            }
          />
        </Dropdown.Option>
        <Dropdown.Option value="image">
          <VideoStudioContext
            CustomButton={
              ({ onClick }) => (
                <div onClick={onClick}>
                  <Trans>Image Template</Trans>
                </div>
              )
            }
          />
        </Dropdown.Option>
        <Dropdown.Option value="montage">
          <VideoStudioContext
            CustomButton={
              ({ onClick }) => (
                <div onClick={onClick}>
                  <Trans>Montage Template</Trans>
                </div>
              )
            }
          />
        </Dropdown.Option>
      </Dropdown.ListBox>
    </Dropdown>
  );
};

export default CreateTemplateButton;
